import { render, staticRenderFns } from "./DiscoverFilters.vue?vue&type=template&id=bf528166&scoped=true&"
import script from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
export * from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverFilters.vue?vue&type=style&index=0&id=bf528166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf528166",
  null
  
)

export default component.exports